import { duration } from "moment";
import React, { useState } from "react";
import { FaCheck, FaTimes } from "react-icons/fa";
import { MdOutlineClose } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const studentPlans = [
  {
    name: "Basic Plan",
    price: "₹599/-",
    originalPrice: "₹999/-",
    features: [
      { text: "AI Interviews", available: true, value: 3 },
      { text: "MCQ Assessments", available: true, value: 3 },
      { text: "Resume Analyser", available: true, value: 3 },
      { text: "Detailed Analytical Report", available: true },
      { text: "Days Interview Video Backup", available: true, value: 15 },
      { text: "Job Application", available: true, value: 1 },
      { text: "Assured Internship", available: false },
      { text: "Profile Boost", available: false },
      { text: "Premium Account Badge", available: false },
      { text: "Days Validity", available: false, value: 30 },
      { text: "Alerts & Notifications", available: false },
      { text: "ATS", available: false },
      { text: "Performance Analytical Report", available: false },
    ],
  },
  {
    name: "Starter Plan",
    price: "₹5,999/-",
    // originalPrice: "₹5,999",
    features: [
      { text: "AI Interviews", available: true, value: 50 },
      { text: "MCQ Assessments", available: true, value: 30 },
      { text: "Resume Analyser", available: true, value: 50 },
      { text: "Detailed Analytical Report", available: true },
      { text: "Days Interview Video Backup", available: true, value: 30 },
      { text: "Job Application", available: true, value: 30 },
      { text: "Profile Boost", available: true, bold: true },

      { text: "Days Validity", available: true, value: 365, bold: true },
      { text: "Alerts & Notifications", available: true, bold: true },
      { text: "ATS", available: true, bold: true },
      { text: "Performance Analytical Report", available: true, bold: true },
      { text: "Assured Internship", available: false },
      { text: "Premium Account Badge", available: false },
    ],
  },
  {
    name: "Advanced Plan",
    price: "₹7,999/-",
    // originalPrice: "₹8,499",
    features: [
      { text: "Assured Internship", available: true, bold: true },
      { text: "Unlimited AI Interviews", available: true },
      { text: "Unlimited MCQ Assessments", available: true },
      { text: "Unlimited Resume Analyser", available: true },
      { text: "Detailed Analytical Report", available: true },
      { text: "Days Interview Video Backup", available: true, value: 60 },
      { text: "Unlimited Job Application", available: true },
      { text: "Profile Boost", available: true },
      { text: "Premium Account Badge", available: true, bold: true },
      { text: "Days Validity", available: true, value: 365 },
      { text: "Alerts & Notification", available: true },
      { text: "ATS", available: true },
      { text: "Performance Analytical Report", available: true },
    ],
  },
];

const companyPlans = [
  {
    id: "67cad464cc2bec83fe4e8ad2",
    name: "Starter Plan",
    price: "₹999/-",
    duration: "per month",
    // originalPrice: "₹11,999",
    features: [
      { text: "AI Resume Analyser", available: true, value: 100 },
      { text: "AI Interviews", available: true, value: 20 },
      { text: "MCQ's", available: true, value: 200 },
      { text: "Reports", available: true },
      { text: "ATS Dashboard", available: true },
      { text: "Tags", available: true },
      { text: "Salary recommendation", available: true },
      { text: "Proxy detection", available: true },
      { text: "Job Post/Month", available: true, value: 2 },
      { text: "Login", available: true, value: 3 },
      { text: " Day Interview Backup", available: true, value: 15 },
      { text: "White Labelling", available: true },
      { text: "Shared Support", available: true },
      { text: "Dedicated HR Support", available: false },
    ],
  },
  {
    id: "683ed694f88c82f3fd8e9676",
    name: "Advanced Plan",
    price: "₹2,999/-",
    duration: "per month",
    // originalPrice: "₹11,999",
    features: [
      { text: "AI Resume Analyser", available: true, value: 200 },
      { text: "AI Interviews", available: true, value: 60 },
      { text: "MCQ's", available: true, value: 200 },
      { text: "Reports", available: true },
      { text: "ATS Dashboard", available: true },
      { text: "Tags", available: true },
      { text: "Salary recommendation", available: true },
      { text: "Proxy detection", available: true },
      { text: "Job Post/Month", available: true, value: 2 },
      { text: "Login", available: true, value: 5 },
      { text: " Day Interview Backup", available: true, value: 60 },
      { text: "White Labelling", available: true },
      { text: "Shared Support", available: true },
      { text: "Dedicated HR Support", available: true },
    ],
  },
  {
    id: 2,
    name: "Custom Plan",
    // price: 0,
    // duration: 1,
    // originalPrice: "₹18,499",
    features: [
      { text: "AI Resume Analyser", available: true },
      { text: "AI Interviews", available: true },
      { text: "MCQ's", available: true },
      { text: "Reports", available: true },
      { text: "ATS Dashboard", available: true },
      { text: "Tags", available: true },
      { text: "Salary recommendation", available: true },
      { text: "Proxy detection", available: true },
      { text: "Job Post/Month", available: true },
      { text: "Login", available: true, value: 10 },
      { text: "Day Interview Backup", available: true },
      { text: "In App Auto Emails", available: true },
      { text: "White Labelling", available: true },
      { text: "Shared Support", available: true },
    ],
  },
];
const PlanCard = ({ plan, isStudent, index, buttons }) => {
  const navigate = useNavigate();
  const isMiddle = index === 1;

  return (
    <div
      className={`group min-w-[325px] p-6 rounded-lg shadow-md transition-all w-full md:w-1/3 ${
        isMiddle
          ? "bg-black text-white scale-105 md:scale-110 py-10"
          : "bg-[#f0ebe3] hover:bg-black hover:text-white"
      }`}
    >
      <h2 className="text-xl font-bold mb-4">{plan.name}</h2>
      <div className="text-3xl font-bold mb-2">
        {plan.price}{" "}
        <span className="text-lg line-through">{plan.originalPrice}</span>
        <span className="text-base">{plan.duration}</span>
      </div>
      <ul className="mb-6 space-y-2">
        {plan.features.map((feature, index) => (
          <li key={index} className="flex items-center">
            {feature.available ? (
              <FaCheck className="text-green-500 mr-2" />
            ) : (
              <FaTimes className="text-red-500 mr-2" />
            )}
            <span className={feature.bold ? "font-bold" : ""}>
              {feature.value ? `${feature.value} ` : ""}
              {feature.text}
            </span>
          </li>
        ))}
      </ul>
      {buttons && (
        <button
          className={`w-full py-2 border rounded-full transition-all duration-300 ${
            isMiddle
              ? "border-white text-white hover:bg-orange-500 hover:border-orange-500"
              : "border-black text-black group-hover:text-white group-hover:border-orange-500 hover:bg-orange-500"
          }`}
          onClick={() => {
            if (isStudent) {
              navigate("/dashboard/subscription");
            } else {
              navigate("/company/subscription");
            }
          }}
        >
          Choose the Plan
        </button>
      )}
    </div>
  );
};

const PricingPlans = ({ plans, isStudent, buttons }) => (
  <div className=" flex flex-col items-center justify-center min-h-screen p-8 ">
    <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 gap-4 md:space-x-4">
      {plans.map((plan, index) => (
        <PlanCard
          key={index}
          plan={plan}
          isStudent={isStudent}
          index={index}
          buttons={buttons}
        />
      ))}
    </div>

    <div className="mt-10 md:mt-20 text-base text-center">
      <p>Any quries about it?</p>
      <a
        href="https://www.reaidy.io/contact"
        target="_blank"
        rel="noopener noreferrer"
        className="text-black underline hover:text-primary"
      >
        Contact us
      </a>
    </div>
  </div>
);

const PricingPlan = ({ isStudent1 = true, buttons = true, head = true }) => {
  const [isStudent, setIsStudent] = useState(isStudent1);
  const navigate = useNavigate();
  const bgColor = "#f5f5f5"; // Example, replace with your dynamic value

  const togglePlans = () => {
    setIsStudent(!isStudent);
  };

  return (
    <div className="relative flex  md:mt-0 flex-col items-center justify-center min-h-screen">
      <div className="absolute top-0 right-0 p-4">
        {buttons && (
          <button
            onClick={() => {
              navigate(-1);
            }}
            className=""
          >
            <MdOutlineClose className="text-2xl" />
          </button>
        )}
      </div>
      {/* Added heading here */}
      {head ? (
        <h1 className="text-3xl md:text-4 xl font-bold text-center mb-6">
          Upgrade your plan
        </h1>
      ) : (
        <h1 className="text-3xl md:text-4 xl font-bold text-center mb-6">
          Available Plans
        </h1>
      )}

      {buttons && (
        <div className="flex mb-10 bg-white border border-black rounded-full  ">
          {buttons && (
            <button
              className={`px-5 py-2 rounded-full transition-all font-medium ${
                isStudent ? "bg-black text-white" : "text-black"
              }`}
              onClick={() => setIsStudent(true)}
            >
              Job Seeker
            </button>
          )}
          {buttons && (
            <button
              className={`px-5 py-2 rounded-full transition-all font-medium ${
                !isStudent ? "bg-black text-white" : "text-black"
              }`}
              onClick={() => setIsStudent(false)}
            >
              Recruiter
            </button>
          )}
        </div>
      )}
      <PricingPlans
        plans={isStudent ? studentPlans : companyPlans}
        isStudent={isStudent}
        buttons={buttons}
      />
    </div>
  );
};

export default PricingPlan;
